import Group from "../Models/Group";

export class CompletedCubeService
{
  public static getNumberOfCompletedCubes(group: Group): number
  {
    let lowestCompleteCount = 99;
    group.playerPairs.forEach(x =>
    {
      const completeCount = x.scorecards
        .filter(y => y.completed)
        .length;
      
      if (completeCount < lowestCompleteCount)
      {
        lowestCompleteCount = completeCount;
      }
    });
    
    return lowestCompleteCount;
  }
}